<template>
  <el-select
    :value="vat"
    :disabled="disabled"
    size="small"
    style="width: 100%;"
    value-key="id"
    @change="onVatChange"
  >
    <el-option
      v-for="v in vats"
      :key="v.id"
      :value="v.value"
      :label="`${v.value}%`"
    />
  </el-select>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    vat: {
      type: Number,
      default() {
        return {
          value: null,
        };
      },
      required: false,
    },
  },
  computed: {
    vats() {
      return this.$store.getters['vat/vats'];
    },
  },
  methods: {
    onVatChange(vat) {
      this.$emit('change', vat);
    },
  },
};
</script>
